import { Button, ButtonProps } from './Button';

type Props = ButtonProps;
export function GhostButton(props: Props) {
    return <Button {...props} variant="ghost" />;
}
